import React from 'react'
import { connect } from 'react-redux'
import { VenderInfoContainer } from './styled'
import { compose, lifecycle } from 'recompose'
import { reduxForm, getFormValues, Field, FieldArray } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { Paper, IconButton, Button } from '@material-ui/core'
import { Delete, Add } from '@material-ui/icons'
import { Header } from 'semantic-ui-react'

import r from 'reactotron-react-js'

const numberOfEmployeeOptions = [
  { value: 1, label: '1 - 10' },
  { value: 2, label: '11 - 50' },
  { value: 3, label: '51 - 200' },
  { value: 4, label: '201 - 500' },
  { value: 5, label: '501 - 1000' },
  { value: 6, label: '1000+' }
]

const businessTypeOptions = [
  { value: 'Advertising', text: 'Advertising' }, 
  { value: 'Architecture', text: 'Architecture' }, 
  { value: 'Consultant', text: 'Consultant' }, 
  { value: 'Contractor', text: 'Contractor' }, 
  { value: 'Event', text: 'Event' },
  { value: 'Forwarder', text: 'Forwarder' }, 
  { value: 'Packing', text: 'Packing' }, 
  { value: 'Printing', text: 'Printing' }, 
  { value: 'Sales', text: 'Sales' }, 
  { value: 'Service', text: 'Service' }, 
  { value: 'Shipping', text: 'Shipping' }, 
  { value: 'Sub-contractor', text: 'Sub-contractor' }, 
]

const projectExpIn10YearsOptions = [
  { value: 'Condominium', text: 'Condominium' },
  { value: 'Hotel', text: 'Hotel' },
  { value: 'Department store', text: 'Department store' },
  { value: 'Factory', text: 'Factory' },
  { value: 'Resort', text: 'Resort' },
  { value: 'Housing development', text: 'Housing development' },
  { value: 'Government service', text: 'Government service' },
  { value: 'Hospital', text: 'Hospital' },
  { value: 'Other', text: 'Other' },
]

const renderOtherCertificateInput = ({ fields, meta: { error } }) => {
  return (
    <div>
      {
        fields.map((contact, index) => {
          return (
            <Paper style={{ padding: '15px', paddingTop: '10px', marginTop: '10px' }}>
              <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <Field name={`${contact}.name`} label='Certificate Name' type={type.text} component={FieldInput} containerStyle={{ width: '100%' }} />
                <IconButton style={{ color: 'red' }} aria-label='Delete' onClick={() => fields.remove(index)}>
                  <Delete fontSize='small' />
                </IconButton>
              </div>
              <Field 
                name={`${contact}.file`} 
                label='Select Certificate' 
                replaceFilenameToLabel
                type={type.file} 
                component={FieldInput} />
            </Paper>
          )
        })
      }
      <Button 
        type='button' 
        style={{ marginTop: '10px' }}
        variant='contained' 
        color='primary' 
        onClick={() => fields.push({})}>
        <Add fontSize='small' />
        Add Other Certificate
      </Button>
    </div>
  )
}

const FullVenderInfomationForm = (props) => {
  return (
    <VenderInfoContainer>
      <h1 style={{ margin: 0 }}>Company Information</h1>
      <form>
        <div style={{ display: 'flex', flex: 1, width: '100%', flexDirection: 'row', marginTop: '15px' }}>
          <Paper style={{ padding: '15px', flex: 1 }}>
            <Header as='h2'>Business Information</Header>
            <Field 
              name='personalId'
              label='Business registration / ID card number'
              placeHolder=''
              type={type.text}
              component={FieldInput} />
            <Field 
              name='businessType'
              label='Type of business'
              placeHolder='Select or add your business type'
              type={type.tag} 
              options={businessTypeOptions}
              containerStyle={{ flex: 1 }}
              component={FieldInput} />
            <Field 
              name='remark'
              label='Remark'
              type={type.textArea} 
              containerStyle={{ flex: 1 }}
              component={FieldInput} />
            <Field 
              name='numberOfEmployees'
              label='Number of employees'
              type={type.select}
              options={numberOfEmployeeOptions}
              component={FieldInput}
            />
            <Field 
              name='lastYearRevenue'
              label='Last year revenue'
              type={type.text}
              component={FieldInput} />
            <Field 
              name='lastYearDebt'
              label='Last year debt'
              type={type.text}
              component={FieldInput} />
            <Field 
              name='lastYearProfit'
              label='Last year Profit'
              type={type.text}
              component={FieldInput} />
            <Field 
              name='maxProjectPriceIn10Years'
              label='Maximum project price in past 10 years'
              type={type.text}
              component={FieldInput} />
            <Field 
              name='avgNumberOfProjectsPerYear'
              label='Average number of projects per year'
              type={type.text}
              component={FieldInput} />
            <Field 
              name='totalValueOfCurrentProjects'
              label='Total value of current projects'
              type={type.text}
              component={FieldInput} />
          </Paper>
          <Paper style={{ padding: '15px', marginLeft: '5px', flex: 1 }}>
            <Header as='h2'>Portfolio</Header>
            <Field 
              name='projectExpIn10Years'
              label='Project experiences in 10 years'
              placeHolder='Select or add your project'
              type={type.tag} 
              options={projectExpIn10YearsOptions}
              component={FieldInput} />
            <Header as='h2' style={{ marginTop: '10px' }}>Certificate</Header>
            <Field 
              name='fileISO'
              label='ISO (if any)'
              type={type.file} 
              component={FieldInput} />
            <Field 
              name='fileTQA'
              label='TQA (if any)'
              type={type.file} 
              component={FieldInput} />
            <Field 
              name='FileTISI'
              label='TISI (if any)'
              type={type.file} 
              component={FieldInput} />
            <FieldArray name='otherCertificate' component={renderOtherCertificateInput} />
          </Paper>
        </div>
      </form>
    </VenderInfoContainer>
  )
}

const validate = values => {
  const errors = {}
  if (!values.companyName) {
    errors.companyName = 'Required!'
  }

  return errors
}

const mapStateToProps = (state) => ({
  valueForm: getFormValues('formVenderMin')(state)
})

const mapDispatchToProps = {
  initialValues: {
  }
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formVenderMin',
    validate: validate
  }),
  lifecycle({
    componentDidMount() {
    },
    componentWillReceiveProps(nextProp) { }
  })
)

export default enhance(FullVenderInfomationForm)